import { render, staticRenderFns } from "./ProductLessonScheduleItem.vue?vue&type=template&id=3451cb89&scoped=true&"
import script from "./ProductLessonScheduleItem.vue?vue&type=script&lang=ts&"
export * from "./ProductLessonScheduleItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductLessonScheduleItem.vue?vue&type=style&index=0&id=3451cb89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451cb89",
  null
  
)

export default component.exports